import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import ServiceDetailData from "../data/service/ServiceDetail.json";
import ProjectData from "../data/project/ProjectData.json";
import Tilty from "react-tilty";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";
import { FaAngleRight } from "react-icons/fa";
import SplashData from "../data/splash/SplashData.json";

const getProjectData = ProjectData;
const DemoData = SplashData[0];
const FeatureData = SplashData[1];

const ServiceDetails = () => {
  const params = useParams();
  const categorySlug = params.category;
  const serviceSlug = params.service;

    const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobileOrTablet(window.innerWidth < 1023); // tablet and below
      };
  
      handleResize(); // Initial check
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  

  const getServiceDetails = () => {
    try {
      if (
        ServiceDetailData[categorySlug] &&
        ServiceDetailData[categorySlug][serviceSlug]
      ) {
        return ServiceDetailData[categorySlug][serviceSlug];
      }
      return null;
    } catch (error) {
      console.error("Error fetching service details:", error);
      return null;
    }
  };

  const detailsService = getServiceDetails();

  if (!detailsService) {
    return <div>Service not found</div>;
  }

  // console.log(detailsService.process.steps, "ds");
  const imageHoverStyle = {
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
    },
  };

  return (
    <>
      <SEO title={detailsService?.title} />
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerTwo
          title={detailsService?.title}
          paragraph={detailsService?.description}
          styleClass=""
          mainThumb={detailsService?.image}
          page={detailsService?.title?.replace(/\s+/g, '-')}
        />

        <div
          className="section  spalsh-why-choose"
          id="splash-why-choose"
          style={{ padding:  isMobileOrTablet ? "40px 0px 0px" : "100px 0px 0px" }}
        >
          <div className="container">
            <div className="section-heading heading-left">
              <div className="row align-items-center">
                <div className="col-xl- col-lg-7">
                  {/* <h2
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html: detailsService?.process?.heading,
                    }}
                  ></h2> */}
                </div>
                <div className="col-xl-4 col-lg-5 offset-xl-2"></div>
              </div>
            </div>
            <div
              className="row"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {detailsService?.process?.steps?.map((data) => (
                <div className="col-xl-4 col-lg-6" key={data.id}>
                  <div className="why-buy-box" style={{ minHeight: isMobileOrTablet ? "unset" : "328px" , borderColor:"#562b7a"}}>
                    <div className="heading">
                      {/* <div className="icon">
                        <img
                          src={process.env.PUBLIC_URL + data.icon}
                          alt="Thumb"
                        />
                      </div> */}
                      <h5
                        className="title"
                        style={{color:"#562b7a"}}
                        dangerouslySetInnerHTML={{ __html: data?.title }}
                      ></h5>
                    </div>
                    <p
                      dangerouslySetInnerHTML={{ __html: data?.paragraph }}
                    ></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default ServiceDetails;
